import type { CSSProperties, ReactNode } from 'react'

const SPINNER_KEYFRAMES = '@keyframes fg-loading-overlay-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }'

type LoadingOverlayProps = {
  label: string
  detail?: ReactNode
  background?: string
  style?: CSSProperties
  cardStyle?: CSSProperties
}

export function LoadingOverlay({
  label,
  detail,
  background = 'rgba(255,255,255,0.72)',
  style,
  cardStyle,
}: LoadingOverlayProps) {
  const hasDetail = detail !== null && typeof detail !== 'undefined' && detail !== false

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background,
        pointerEvents: 'none',
        ...style,
      }}
    >
      <style>{SPINNER_KEYFRAMES}</style>
      <div
        style={{
          display: 'flex',
          alignItems: hasDetail ? 'flex-start' : 'center',
          gap: 12,
          padding: hasDetail ? '12px 16px' : '10px 14px',
          borderRadius: hasDetail ? 12 : 999,
          border: '1px solid #e5e7eb',
          background: '#fff',
          boxShadow: '0 10px 30px rgba(15,23,42,0.12)',
          color: '#334155',
          maxWidth: 'min(640px, calc(100% - 48px))',
          ...cardStyle,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            width: 18,
            height: 18,
            flex: '0 0 auto',
            borderRadius: '50%',
            border: '2px solid #cbd5e1',
            borderTopColor: 'var(--fg-progress-fill)',
            animation: 'fg-loading-overlay-spin 0.9s linear infinite',
            marginTop: hasDetail ? 1 : 0,
          }}
        />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.35 }}>{label}</div>
          {hasDetail ? (
            <div style={{ marginTop: 6, fontSize: 12, color: '#64748b', lineHeight: 1.5 }}>
              {detail}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
